import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { RoundAnswer } from "./supplierRows";

export const RoundAnswerTag = ({ answer }: { answer: RoundAnswer }) => {
  const { t } = useTranslation();
  const { color, text } = {
    NewBid: { color: "green", text: t("Delivered a new bid") },
    ConfirmedStandingBid: { color: "teal", text: t("Confirmed standing bid") },
    Declined: { color: "red", text: t("Declined") },
    NoAnswer: { color: "red", text: t("No answer – out of the competition") },
    Awaiting: { color: "gray", text: t("Invited") },
    Rejected: { color: "red", text: t("Rejected") },
    NotInDialogue: { color: "gray", text: t("Not in the dialogue – stays in on its tender") },
    DeclinedStaysOnTender: { color: "gray", text: t("Declined – stays in on its tender") },
    NoAnswerStaysOnTender: { color: "gray", text: t("No answer – stays in on its tender") },
  }[answer];
  return (
    <Tag colorScheme={color} size="sm" textAlign="center" height="8" py="2">
      {text}
    </Tag>
  );
};
